// Avater for use in React Components

import React , {useState} from "react";

export default function UserAvater({url, fallback}) {
    const initials = fallback.split('')[0]
    return (
        <div>
            {url && 
            <div className="avatar-sm">
                <img src={url} className="avatar-img rounded-circle" />
            </div>
            }
            {!url &&
            <span className="avatar bg-primary-gradient text-white rounded-circle">
                <span className="initials">{initials}</span>
            </span>
            }
        </div>
    )
}